// Логика раскладки диаграмм без зависимостей от React и Recharts (проверяется тестами)

// Минимальная ширина столбца, при которой подпись под ним ещё читается
export const MIN_BAND = 48;
export const CHAR_WIDTH = 6.5;
export const TICK_LINES = 3;

/** Тип диаграммы по умолчанию: вертикальная, пока подписи помещаются под столбцами, иначе горизонтальная. */
export function autoChartType(question, width) {
  const options = question.options || [];
  const count = options.length;
  if (count === 0) return 'bar';
  if (count > 8) return 'horizontal';
  const longest = Math.max(...options.map((o) => String(o.text || '').length));
  const band = (width || 900) / count;
  // Подпись должна уложиться в 3 строки под своим столбцом
  if (band < 70 || longest * CHAR_WIDTH > band * TICK_LINES * 0.9) return 'horizontal';
  return 'bar';
}

/** Пользователь выбрал тип или берём автоматический; круговая — только для одного ответа. */
export function resolveChartType(question, chosen, width) {
  const type = chosen || autoChartType(question, width);
  if (type === 'pie' && question.allow_multiple) return 'bar';
  return type;
}

export function splitLabel(text, maxChars, maxLines) {
  const words = String(text).split(/\s+/).filter(Boolean);
  const lines = [];
  let current = '';
  const push = (line) => lines.push(line);
  words.forEach((word) => {
    // Слово длиннее строки не рвём посередине, а сокращаем с многоточием
    const rest = word.length > maxChars ? `${word.slice(0, maxChars - 1)}…` : word;
    if (!current) current = rest;
    else if (current.length + 1 + rest.length <= maxChars) current += ` ${rest}`;
    else { push(current); current = rest; }
  });
  if (current) push(current);
  if (lines.length <= maxLines) return lines;
  const cut = lines.slice(0, maxLines);
  const last = cut[maxLines - 1];
  cut[maxLines - 1] = `${last.slice(0, Math.max(1, maxChars - 1))}…`;
  return cut;
}
